import { KnownIssuePlatform, KnownIssuePlatformLabel } from "./types";

export const platformsToPlatformsLabelMap: Record<KnownIssuePlatform, KnownIssuePlatformLabel> = {
  [KnownIssuePlatform.AWS]: KnownIssuePlatformLabel.AWS,
  [KnownIssuePlatform.GCP]: KnownIssuePlatformLabel.GCP,
  [KnownIssuePlatform.GSuite]: KnownIssuePlatformLabel.GSuite,
  [KnownIssuePlatform.Office365]: KnownIssuePlatformLabel.Office365,
};
